import http from '@/biz/http.mjs'
import extendNode from '../extendNode.mjs'
import parseMap from '../../scripts/parseMap.mjs'
import Color from '../Color.mjs'
import useProductNode from '../_PRODUCT/useProductNode.jsx'
import IconLetters from '../icons/IconLetters.jsx'
import meta from './metaDt.mjs'
import Model from './ModelDt.mjs'
import PropertiesPane from './PropertiesPaneDt.jsx'
import FormChoose from './FormChooseDt.jsx'
import TableChoose from './TableChooseDt.jsx'
import api from './apiDt.mjs'
import useContextMenu from './useContextMenuDt.jsx'

export default () => {
    const ProductNode = useProductNode()
    const contextMenu = useContextMenu()

    return extendNode(ProductNode, {
        ...meta,
        api,
        contextMenu,
        FormChoose,
        TableChoose,
        Model,
        PropertiesPane,

        canChangeVersion(map, node) {
            const {bizNodeType} = node.parent?.data ?? {}

            return (
                'DF' === bizNodeType ||
                ProductNode.canChangeVersion.call(this, map, node)
            )
        },

        canMountType(map, node, type) {
            return (
                ProductNode.canMountType.call(this, map, node, type) ||
                /^(CAT|BK|DF|PK)$/.test(type)
            )
        },

        async choose(map, node) {
            const {prjNo} = map.data

            const getQuery = ({dms = [], ...query}) => {
                const dbCode = (() => {
                    const p = node.trueParent

                    if (! p) {
                        return
                    }

                    const {bizNodeType} = p.data

                    if ('DV_DS' === bizNodeType) {
                        return p.parent.data.dbCode
                    }
                })()

                return {
                    prjNo,
                    ...query,
                    dbCode,
                    dmIds: dms.map(({dmId}) => dmId),
                }
            }

            return this._choose(map, node, {getQuery})
        },

        getIcons(map, node) {
            if (node.data.pkid) {
                return []
            }
            else {
                return [
                    <IconLetters
                        key="type"
                        fill={Color.DARK_CYAN}
                        letters="DT"
                        textColor="#666"
                    />
                ]
            }
        },

        getTextLower(map, node) {
            return node.data[this.codeProp]
        },

        getTextSuffix(map, node) {
            const {dtAlias} = node.data

            if (dtAlias) {
                return ` (${dtAlias})`
            }
            else {
                return ProductNode.getTextSuffix.call(this, map, node)
            }
        },

        getTextUpper(map, node) {
            const {doName} = node.data

            if (doName) {
                return `《${doName}》`
            }
            else {
                return ''
            }
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'CAT'},
            ]
        },

        menuItemsInsertConcept(map, node) {
            return [
                {type: 'DF'},
            ]
        },

        async upgrade(map, node) {
            await ProductNode.upgrade.call(this, map, node)
            const p = node.parent

            if ('DF' === p?.data?.bizNodeType) {
                map.BizNode.DF._upgradeFk(map, p)
            }
        },

        _getShape(map, node) {
            return 'SingleBreakangle'
        },

        _getThemeColor(map, node) {
            return Color.CYAN
        },

        async _onAttach(map, node, event) {
            const n = event.target
            const {bizNodeType, isBk, isPk} = n.data

            if ('DF' === bizNodeType) {
                if ('1' === isBk) {
                    (() => {
                        // 不使用正则替换的原因是无法处理以下情况：
                        // 需处理的字段A名称包含分隔符，而字段B名称为空

                        const names = this._getKeyNames(map, node, 'isBk')
                        const dfName = names.join('+')
                        let bk = this._findBk(map, node)

                        if (bk) {
                            bk.data = {...bk.data, dfName}
                            return
                        }

                        bk = map.createNode('BK')
                        bk.data = {...bk.data, dfName}

                        const pk = [...node.children].find(
                            e => 'PK' === e.data.bizNodeType
                        )

                        if (pk) {
                            map.insertSiblingAfter(pk, bk)
                            return
                        }

                        const trigger = [...node.children].find(
                            e => 'DT_TRIGGER' === e.data.bizNodeType
                        )

                        if (trigger) {
                            map.insertSiblingAfter(trigger, bk)
                            return
                        }

                        map.prependChild(node, bk)
                    })()
                }

                if ('1' === isPk) {
                    (() => {
                        // 不使用正则替换的原因是无法处理以下情况：
                        // 需处理的字段A名称包含分隔符，而字段B名称为空

                        const names = this._getKeyNames(map, node, 'isPk')
                        const dfName = names.join('+')
                        let pk = this._findPk(map, node)

                        if (pk) {
                            pk.data = {...pk.data, dfName}
                            return
                        }

                        pk = map.createNode('PK')
                        pk.data = {...pk.data, dfName}

                        const trigger = [...node.children].find(
                            e => 'DT_TRIGGER' === e.data.bizNodeType
                        )

                        if (trigger) {
                            map.insertSiblingAfter(trigger, pk)
                            return
                        }

                        map.prependChild(node, pk)
                    })()
                }
            }

            await ProductNode._onAttach.call(this, map, node, event)
        },

        async _onChange(map, node, event) {
            const n = event.target
            const oldData = event.detail
            const newData = n.data

            if (n === node) {
                const {dbCode} = newData

                if (oldData.dbCode && dbCode !== oldData.dbCode) {
                    node.data = {
                        ...node.data,
                        dmCode: '',
                        dmId: '',
                        dmName: '',
                    }
                }
            }
            else if (
                'DF' === newData.bizNodeType &&

                (
                    ! newData.pkid ||
                    node.data.pkid === newData.dtId
                )
            ) {
                if (
                    newData.isBk !== oldData.isBk ||

                    (
                        '1' === newData.isBk &&
                        newData.dfName !== oldData.dfName
                    )
                ) {
                    (() => {
                        // 不使用正则替换的原因是无法处理以下情况：
                        // 需处理的字段A名称包含分隔符，而字段B名称为空

                        const names = this._getKeyNames(map, node, 'isBk')
                        const bk = this._findBk(map, node)

                        if (bk) {
                            if (0 < names.length) {
                                const dfName = names.join('+')
                                bk.data = {...bk.data, dfName}
                            }
                            else {
                                map.deleteTree(bk)
                            }
                        }
                        else if (0 < names.length) {
                            const bk = map.createNode('BK')
                            const dfName = names.join('+')
                            bk.data = {...bk.data, dfName}

                            const pk = [...node.children].find(
                                e => 'PK' === e.data.bizNodeType
                            )

                            if (pk) {
                                map.insertSiblingAfter(pk, bk)
                                return
                            }

                            const trigger = [...node.children].find(
                                e => 'DT_TRIGGER' === e.data.bizNodeType
                            )

                            if (trigger) {
                                map.insertSiblingAfter(trigger, bk)
                                return
                            }

                            map.prependChild(node, bk)
                        }
                    })()
                }

                if (
                    newData.isPk !== oldData.isPk ||

                    (
                        '1' === newData.isPk &&
                        newData.dfName !== oldData.dfName
                    )
                ) {
                    (() => {
                        // 不使用正则替换的原因是无法处理以下情况：
                        // 需处理的字段A名称包含分隔符，而字段B名称为空

                        const names = this._getKeyNames(map, node, 'isPk')
                        const pk = this._findPk(map, node)

                        if (pk) {
                            if (0 < names.length) {
                                const dfName = names.join('+')
                                pk.data = {...pk.data, dfName}
                            }
                            else {
                                map.deleteTree(pk)
                            }
                        }
                        else if (0 < names.length) {
                            const pk = map.createNode('PK')
                            const dfName = names.join('+')
                            pk.data = {...pk.data, dfName}

                            const trigger = [...node.children].find(
                                e => 'DT_TRIGGER' === e.data.bizNodeType
                            )

                            if (trigger) {
                                map.insertSiblingAfter(trigger, pk)
                                return
                            }

                            map.prependChild(node, pk)
                        }
                    })()
                }
            }

            await ProductNode._onChange.call(this, map, node, event)
        },

        async _onDelete(map, node, event) {
            const n = event.target
            const {bizNodeType, dfName: dfn, isBk, isPk} = n.data

            if ('DF' === bizNodeType) {
                if ('1' === isBk) {
                    const bk = this._findBk(map, node)

                    if (! bk) {
                        return
                    }

                    // 不使用正则替换的原因是无法处理以下情况：
                    // 需处理的字段A名称包含分隔符，而字段B名称为空

                    const names = this._getKeyNames(map, node, 'isBk')

                    if (1 < names.length) {
                        const dfName = names.filter(n => n !== dfn).join('+')
                        bk.data = {...bk.data, dfName}
                    }
                    else {
                        map.deleteTree(bk)
                    }
                }

                if ('1' === isPk) {
                    const pk = this._findPk(map, node)

                    if (! pk) {
                        return
                    }

                    // 不使用正则替换的原因是无法处理以下情况：
                    // 需处理的字段A名称包含分隔符，而字段B名称为空

                    const names = this._getKeyNames(map, node, 'isPk')

                    if (1 < names.length) {
                        const dfName = names.filter(n => n !== dfn).join('+')
                        pk.data = {...pk.data, dfName}
                    }
                    else {
                        map.deleteTree(pk)
                    }
                }
            }

            await ProductNode._onChange.call(this, map, node, event)
        },

        async _atCreate(map, node) {
            for (const n of map.chain(node.parent)) {
                const {
                    bizNodeType,
                    dbCode,
                    dbId,
                    dbName,
                    dmCode,
                    dmId,
                    dmName,
                } = n.data

                if ('CAT_ROOT_DM' === bizNodeType) {
                    node.data = {
                        ...node.data,
                        dbCode,
                        dbId,
                        dbName,
                        dmCode,
                        dmId,
                        dmName,
                    }

                    break
                }
            }

            await ProductNode._atCreate.call(this, map, node)
        },

        _findBk(map, node) {
            return [...node.children].find(
                e => 'BK' === e.data.bizNodeType
            )
        },

        _findPk(map, node) {
            return [...node.children].find(
                e => 'PK' === e.data.bizNodeType
            )
        },

        _fixChild(map, node, child) {
            const {bizNodeType} = child.data

            if ('DGF' === bizNodeType) {
                map.BizNode.DF.castFrom(map, child)
                return true
            }
            else {
                return ProductNode._fixChild.call(this, map, node, child)
            }
        },

        _getCategories(map, node) {
            return [
                'DT_TRIGGER',
            ]
        },

        _getKeyNames(map, node, isKeyProp) {
            const next = chain => {
                const {bizNodeType, [isKeyProp]: isKey} = chain[0].data
                const _n = map.nodeProxy(chain[0])
                const isMounted = _n.isMounted()

                const yieldNode = (
                    isMounted &&
                    'DF' === bizNodeType &&
                    '1' === isKey
                )

                const yieldChildren = isMounted && 'CAT' === bizNodeType
                return {yieldChildren, yieldNode}
            }

            return [...map.dfs(node.children, next)].map(e => e.data.dfName)
        },

        _pushDataSlots: {
            dmDfList: [],
        },

        async _onInsert(map, node) {
            const p = node.trueParent

            if (p) {
                const {arTypeCode, bizNodeType} = p.data

                if (
                    'AR' === bizNodeType &&
                    /^DB_[CU]$/.test(arTypeCode)
                ) {
                    const {pkid} = node.data
                    const {children} = await map.BizNode.DT.readTree({pkid})
                    const ar = map.createNode('AR')
                    ar.data = {...ar.data, arName: '', arTypeCode: 'SET_DF'}
                    map.insertSiblingAfter(node, ar)
                    await map.BizNode.AR.emitEventUp(map, ar, {type: 'create'})

                    for (const tree of children) {
                        const {bizNodeType} = tree.data

                        if (/^(BK|DT_TRIGGER|PK)$/.test(bizNodeType)) {
                            continue
                        }

                        const child = map.importTree(tree)
                        map.appendChild(ar, child)
                        // TODO
                        //await map.BizNode[bizNodeType].onAttachTo(map, child)
                    }
                }
            }

            await ProductNode._onInsert.call(this, map, node)
        },

        async _readGrowTree(map, node) {
            const {mapTypeCode} = map.data

            if (/^(D[AT]_REFERENCE_MAP|SA_MAP)$/.test(mapTypeCode)) {
                const {pkid, prjId, sVer} = node.data

                const result = await http.get(
                    '/llmDtGenDo/extendDt',
                    {mapTypeCode, pkid, prjId, sVer}
                )

                const children = parseMap(result)
                return {children, data: node.data}
            }
            else {
                return ProductNode._readGrowTree.call(this, map, node)
            }
        },
    })
}
